<template>
  <v-container>
    <v-card class="my-5 elevation-0" height="100%">
      <v-card-title>
        <v-btn text small @click="$router.back()">
          <v-icon left> mdi-arrow-left </v-icon>
          Back
        </v-btn>
        <v-spacer />
        <!-- Native iframe has its own download functionality -->
        <!-- <v-btn small color="secondary" @click="downloadLink(document)">
          <v-icon left> mdi-download </v-icon>
          Download
        </v-btn> -->
      </v-card-title>
      <v-divider />

      <v-row>
        <v-col cols="12" md="8" offset-md="2">
          <!-- PDF Viewer Iframe (Desktop) / Mobile Placeholder -->
          <v-card-text
            v-if="document"
            class="pa-0 elevation-1 mb-1"
            :style="{
              height: isMobile ? 'auto' : '80vh',
              minHeight: isMobile ? '300px' : '700px',
              position: 'relative',
              background: isMobile ? '#ffffff' : '#525659'
            }"
          >
            <!-- Loader while Blob URL is being created/loaded -->
            <div v-if="!pdfUrl" class="pa-4 white" style="height: 100%">
              <v-skeleton-loader type="image" height="100%" />
            </div>

            <template v-else>
              <!-- Mobile Optimized View -->
              <div
                v-if="isMobile"
                class="pa-12 text-center d-flex flex-column align-center justify-center"
              >
                <v-icon size="100" color="primary lighten-4"
                  >mdi-file-pdf-box</v-icon
                >
                <div class="mt-6 grey--text text--darken-2 headline font-weight-bold">
                  Document Preview
                </div>
                <div class="mt-2 grey--text subtitle-1 mb-8">
                  Your document is ready. Since you are on a mobile device, please
                  use the button below to view it.
                </div>
                <v-btn
                  x-large
                  color="primary"
                  class="text-none px-8 rounded-lg shadow-lg"
                  @click="openPdfInNewTab"
                >
                  <v-icon left>mdi-eye</v-icon>
                  Open Document
                </v-btn>
                <div class="mt-4 grey--text caption">
                  The document will open in your device's native PDF viewer.
                </div>
              </div>

              <!-- Desktop Iframe View -->
              <iframe
                v-else
                :src="pdfUrl"
                width="100%"
                height="100%"
                frameborder="0"
                style="border: none; display: block"
                title="Petty Cash Document Viewer"
                loading="lazy"
              ></iframe>
            </template>
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>
<script>
import FileMixin from "@kinetics254/cassandra-base/mixins/FileMixin";
export default {
  name: "PettycashDocument",
  mixins: [FileMixin],
  data() {
    return {
      pdfUrl: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("pettycash/getPettyCashDocument", to.params.docNo);
    });
  },
  computed: {
    document() {
      return this.$store.getters["pettycash/pettycashstate"](
        "pettycashDocument"
      );
    },
    isMobile() {
      // Production-grade mobile detection
      return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ) || window.innerWidth <= 768
      );
    },
  },
  watch: {
    document: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.generatePdfUrl(newValue);
        }
      },
    },
  },
  methods: {
    generatePdfUrl(base64Data) {
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl);
      }
      try {
        const binaryString = window.atob(base64Data);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], { type: "application/pdf" });
        this.pdfUrl = URL.createObjectURL(blob);
      } catch (e) {
        console.error("Error generating PDF URL", e);
      }
    },
    openPdfInNewTab() {
      if (!this.pdfUrl) return;
      window.open(this.pdfUrl, "_blank");
    },
  },
  beforeDestroy() {
    if (this.pdfUrl) {
      URL.revokeObjectURL(this.pdfUrl);
    }
  },
};
</script>
<style scoped>
.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}
</style>
